import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './locationFields.css';

export interface ILocationFieldsProps {
  published: boolean;
}
export const LocationFields = ({ children, published }: React.PropsWithChildren<ILocationFieldsProps>) => {
  return (
    <div
      className={clsx(styles['component'], !published && /* istanbul ignore next  */ styles['component--unpublished'])}
    >
      {children}
    </div>
  );
};
